import { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const { t } = useLang();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      const res = await axios.post(`${API}/newsletter`, { email });
      if (res.data.status === "exists") toast.info(t("news_already") || "Already subscribed!");
      else { toast.success("Welcome to Serava Sports!"); setEmail(""); }
    } catch { toast.error("Something went wrong."); }
    finally { setLoading(false); }
  };

  return (
    <section data-testid="newsletter-section" className="py-24 md:py-32 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="max-w-2xl mx-auto text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
            <span className="text-xs tracking-[0.3em] uppercase text-[#C5A059] font-['Outfit'] font-semibold block mb-4">{t("news_tag")}</span>
            <h2 className="font-['Cormorant_Garamond'] text-4xl sm:text-5xl font-light tracking-tight text-white mb-4">{t("news_title")}<br /><span className="italic text-white/70">{t("news_title_italic")}</span></h2>
            <p className="text-white/50 font-['Outfit'] font-light text-base mb-10 max-w-md mx-auto leading-relaxed">{t("news_desc")}</p>
          </motion.div>
          <motion.form initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.2 }} onSubmit={handleSubmit} data-testid="newsletter-form" className="flex flex-col sm:flex-row gap-3">
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t("news_placeholder")} required data-testid="newsletter-email-input"
              className="flex-1 bg-[#141414] border border-[#262626] px-5 py-4 text-white font-['Outfit'] font-light text-sm placeholder:text-white/30 focus:outline-none focus:border-[#C5A059]/50 transition-colors" />
            <button type="submit" disabled={loading} data-testid="newsletter-submit-btn"
              className="btn-primary px-8 py-4 text-xs tracking-[0.15em] uppercase font-['Outfit'] flex items-center justify-center gap-2 disabled:opacity-50">
              {loading ? t("news_subscribing") : t("news_btn")} {!loading && <ArrowRight size={14} />}
            </button>
          </motion.form>
        </div>
      </div>
    </section>
  );
}
